import React, { Fragment, useState, useCallback } from 'react';
import styled from 'styled-components';
import { array, string } from 'prop-types';

import { BaseOutlineButton } from 'library/components/button';
import CreateOutcomeModal from 'apps/journey/pages/professional-center/professional-outcomes/components/create-outcomes-modal';
import { TableDataContext } from 'library/components/data-table/components/data-provider';
import KeyCodes from 'library/helpers/key-codes';
import PlusSVG from 'library/icons/plus.svg';

const StyledPlusSVG = styled(PlusSVG)`
  color: #7ab3c39e;
  margin-right: 0.25em;
`;

const CreateOutcomesButton = ({ label, ariaLabel, tagOptions }) => {
  const [createOutcomeActive, setCreateOutcomeActive] = useState(false);

  const toggleActive = useCallback(() => {
    setCreateOutcomeActive(!createOutcomeActive);
  }, [createOutcomeActive]);

  const handleKeyPress = (e) => {
    if (KeyCodes.POSITIVE_AFFIRMATION.includes(e.which)) {
      toggleActive();
    }
  };

  return (
    <Fragment>
      <BaseOutlineButton
        aria-label={ariaLabel}
        onClick={toggleActive}
        onKeyPress={handleKeyPress}
        tabIndex={0}
      >
        <StyledPlusSVG />
        {label}
      </BaseOutlineButton>
      <TableDataContext.Consumer>
        {(data) =>
          data.selectedRecords.length > 0 ? (
            <CreateOutcomeModal
              active={createOutcomeActive}
              toggleActive={toggleActive}
              records={data.records}
              selectedRecords={data.selectedRecords}
              reloadTable={data.reloadTable}
              tagOptions={tagOptions}
            />
          ) : null
        }
      </TableDataContext.Consumer>
    </Fragment>
  );
};

CreateOutcomesButton.propTypes = {
  label: string,
  ariaLabel: string,
  tagOptions: array,
};

export default CreateOutcomesButton;
